import React from 'react'
import { styled } from '@mui/material'
import DoughnutChart from '../Charts/DonutChart/DoughnutChart'

const idletimeDataMapper = (dataObj) => {
  if (!dataObj || typeof dataObj !== 'object') {
    return { labels: [], values: [], colors: [] }
  }

  const chartData = []
  for (const [key, valueObj] of Object.entries(dataObj)) {
    if (valueObj?.time > 0) {
      chartData.push({
        label: key,
        value: valueObj.time,
        color: valueObj.color || '#cccccc'
      })
    }
  }

  chartData.sort((a, b) => b.value - a.value)

  return {
    labels: chartData.map((el) => el.label),
    values: chartData.map((el) => el.value),
    colors: chartData.map((el) => el.color)
  }
}

const Container = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid lightgray',
  borderRadius: '12px',
  backgroundColor: '#fff'
}))

const CardHeader = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px',
  borderBottom: '1px solid lightgray',
  '& h3, & h4': {
    margin: 0,
    fontSize: '14px',
    fontWeight: 600
  }
}))

const CardBody = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px',
  minHeight: '300px'
}))

const EmptyMessage = styled('p')(() => ({
  color: '#666',
  fontStyle: 'italic'
}))

const ChartWithoutControls = ({ idleTimeData }) => {
  if (
    !idleTimeData ||
    typeof idleTimeData !== 'object' ||
    Object.keys(idleTimeData).length === 0
  ) {
    return <EmptyMessage>No idle time recorded.</EmptyMessage>
  }

  const chartData = idletimeDataMapper(idleTimeData)
  const totalCount = chartData.values.reduce((acc, val) => acc + val, 0)

  if (totalCount === 0) {
    return <EmptyMessage>No idle time recorded.</EmptyMessage>
  }

  return (
    <Container>
      <CardHeader>
        <h3>Idletime</h3>
        <h4>Total Idletime: {totalCount.toFixed(0)} minutes</h4>
      </CardHeader>
      <CardBody>
        <DoughnutChart
          chartTitle=""
          chartLabels={chartData.labels}
          dataGroup={chartData.values}
          backgroundColors={chartData.colors}
        />
      </CardBody>
    </Container>
  )
}

export default ChartWithoutControls
